module.exports = __webpack_public_path__ + "00fe80453d40642e944cfe15fb182b54.svg";